import { defineField, defineType } from 'sanity'
import { strongEmLinkWithReadMore } from '../../data/richText'

export default defineType({
  name: 'fitment',
  title: 'Fitment Types',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'shortName',
      title: 'Short name',
      description:
        'Short name appears at the top of each specific fitment section in the fitment guides. If no description is provided, the system will automatically use the name field as the heading instead.',
      type: 'string',
    }),
    defineField({
      name: 'slug',
      title: 'Slug',
      type: 'slug',
      description:
        'Fitment type does not have dedicated page on the frontend. We are using this slug to generate URLs for the gallery pages filter ie. `?fitment=race`.',
      validation: (Rule) => Rule.required(),
      options: {
        source: 'name',
        maxLength: 50,
      },
    }),
    defineField({
      name: 'subHeading',
      title: 'Subheading',
      type: 'string',
    }),
    defineField({
      title: 'Description',
      name: 'description',
      type: 'array',
      of: strongEmLinkWithReadMore,
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'Untitled' }) {
      return {
        title,
        subtitle: 'Fitment type',
      }
    },
  },
})